import Phaser from 'phaser';
import { Direction } from '@shared/types/entity';

/**
 * Sprites de botas:
 * - 1 fila, 4 columnas (sin animación).
 * - Col 0: mira abajo
 * - Col 1: mira derecha
 * - Col 2: mira izquierda
 * - Col 3: mira arriba
 *
 * Los PNG de boot (`boot1.png`, etc.) son una tira
 * horizontal de 4 columnas x 1 fila, similar a los heads.
 */
const BOOT_COLUMNS = 4;
const BOOT_FRAME_WIDTH = 23; // Ajustar según el tamaño real de los frames
const BOOT_FRAME_HEIGHT = 30; // Ajustar según el tamaño real de los frames

export function getBootSpriteKey(bootId: number): string {
  return `boot${bootId}`;
}

export function preloadBootSprites(scene: Phaser.Scene, bootIds: number[]): void {
  for (const id of bootIds) {
    const key = getBootSpriteKey(id);
    // Asegurarnos de que el recurso sea SIEMPRE un spritesheet
    if (scene.textures.exists(key)) {
      scene.textures.remove(key);
    }

    scene.load.spritesheet(key, `assets/boot/${key}.png`, {
      frameWidth: BOOT_FRAME_WIDTH,
      frameHeight: BOOT_FRAME_HEIGHT,
    });
  }
}

/**
 * Devuelve el índice de frame de bota según la dirección.
 * 0: abajo, 1: derecha, 2: izquierda, 3: arriba.
 */
export function getBootFrameForDirection(dir: Direction): number {
  switch (dir) {
    case Direction.DOWN:
      return 0;
    case Direction.RIGHT:
      return 1;
    case Direction.LEFT:
      return 2;
    case Direction.UP:
      return 3;
    default:
      return 0;
  }
}

